import React from "react";
import DataTable from "react-data-table-component";
import ClipLoader from "react-spinners/ClipLoader";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { TbEdit, TbSettings, TbTrash } from "react-icons/tb";
import moment from "moment";

import { PROMTOUR_TYPES } from "./ModalAdd";

function formatDate(value) {
  if (!value) {
    return "";
  }
  return moment(value).format("DD.MM.YYYY");
}

function getTypeName(idType) {
  return PROMTOUR_TYPES.find((t) => t.value === idType)?.label || idType;
}

function formatParticipantsCount(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  return value;
}

function Table({
  load,
  data,
  total,
  handlePageChange,
  handlePerRowsChange,
  toggleModal,
  toggleModalDelete,
}) {
  const paginationOptions = {
    rowsPerPageText: "Данных на странице:",
    rangeSeparatorText: "из",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: "Все",
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Код</span>,
      selector: (row) => row.Id,
      sortable: true,
      width: "70px",
    },
    {
      name: <span className="font-weight-bold fs-13">Наименование</span>,
      selector: (row) => row.Title,
      sortable: true,
      minWidth: "160px",
    },
    {
      name: <span className="font-weight-bold fs-13">Тип</span>,
      selector: (row) => getTypeName(row.IdType),
      sortable: true,
      minWidth: "140px",
    },
    {
      name: <span className="font-weight-bold fs-13">Дата</span>,
      selector: (row) => formatDate(row.Date),
      sortable: true,
      width: "110px",
    },
    {
      name: <span className="font-weight-bold fs-13">Отрасль</span>,
      selector: (row) => row.Industry || "—",
      sortable: true,
      minWidth: "120px",
    },
    {
      name: <span className="font-weight-bold fs-13">Город/район</span>,
      selector: (row) => row.City || "—",
      sortable: true,
      minWidth: "120px",
    },
    {
      name: <span className="font-weight-bold fs-13">Целевая группа</span>,
      selector: (row) => row.TargetGroup || "—",
      sortable: true,
      minWidth: "140px",
    },
    {
      name: <span className="font-weight-bold fs-13">Участники</span>,
      selector: (row) => formatParticipantsCount(row.ParticipantsCount),
      sortable: true,
      width: "110px",
    },
    {
      name: <span className="font-weight-bold fs-13">Контактное лицо</span>,
      selector: (row) => row.ContactPerson || "—",
      sortable: true,
      minWidth: "140px",
    },
    {
      name: <span className="font-weight-bold fs-13">Адрес</span>,
      selector: (row) => row.Address || "—",
      sortable: true,
      minWidth: "120px",
    },
    {
      name: <span className="font-weight-bold fs-13">Действия</span>,
      sortable: false,
      width: "90px",
      center: true,
      compact: true,
      cell: (cellProps) => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-outline-secondary btn-sm d-flex justify-content-center"
              tag="button"
            >
              <TbSettings size={18} />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                className="edit-item-btn"
                onClick={() => toggleModal(cellProps)}
              >
                <TbEdit size={16} className="me-2" />
                Изменить
              </DropdownItem>
              <DropdownItem
                className="remove-item-btn"
                onClick={() => toggleModalDelete(cellProps)}
              >
                <TbTrash size={16} className="me-2" />
                Удалить
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      progressComponent={<ClipLoader />}
      progressPending={load}
      paginationTotalRows={total}
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
      pagination
      paginationServer
      paginationComponentOptions={paginationOptions}
    />
  );
}

export default Table;
